import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import { FieldArray } from 'redux-form';
import AddOnsCards from '../app-bookings-update/guest/forms/fieldSets/AddOnsCards';
import { FormattedMessage } from 'react-intl';

export default class RequestAddOns extends Component {
  componentDidMount () {
    const { booking, listing, publicAddOns } = this.props;
    window.scrollTo(0, 0);

    const contracts = [
      get(booking, 'booking.master', {}),
      ...get(booking, 'booking.children', [])
    ];

    analyticsIntegrations.bkgReqAddOnsStepViewed(contracts, listing, publicAddOns);
  }

  render () {
    const {
      addOnsValues = [],
      addOns = [],
      formName = '',
      dispatch = null,
      handleAddOnChange = null,
      spaceRental = {},
      toggleModal = null,
      whichModal = null,
      addOnsCategories = []
    } = this.props;

    return (
      <div>
        {
          !isEmpty(addOns) &&
          <div>
            <div className="add-ons-section">
              <div className="no-top-margin margin-lg-bottom">
                <FormattedMessage
                  id="booking_request.add_ons.subheader"
                  defaultMessage="Select additional items to make your event complete."
                />
              </div>
                <FieldArray
                  component={AddOnsCards}
                  name="addOns"
                  displayAddOns={addOns}
                  handleAddOnChange={handleAddOnChange}
                  formName={formName}
                  dispatch={dispatch}
                  addOnsValues={addOnsValues}
                  spaceRental={spaceRental}
                  displayConciergeBanner={false}
                  toggleModal={toggleModal}
                  whichModal={whichModal}
                  addOnsCategories={addOnsCategories}
                />
            </div>
          </div>
        }
      </div>
    )
  }
}

RequestAddOns.propTypes = {
  addOnsValues: PropTypes.array,
  addOns: PropTypes.array,
  formName: PropTypes.string,
  dispatch: PropTypes.func,
  handleAddOnChange: PropTypes.func,
  spaceRental: PropTypes.object,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string,
  addOnsCategories: PropTypes.array
}
